import React from 'react';
import { Box } from '@mui/material';
import { FormAutocomplete } from '~/components/FormComponents/FormAutocomplete.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { useFormContext } from 'react-hook-form';
import {
  BORROWER_TYPE_OPTIONS,
  FINANCIAL_STATEMENT_FORM_OPTIONS,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/constants.ts';
import {
  BorrowerType,
  type TFinancialConditionFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

interface IBorrowerDetailsSectionProps {
  disabled: boolean;
  readOnly?: boolean;
}

export const BorrowerDetailsSection: React.FC<IBorrowerDetailsSectionProps> = ({
  disabled,
  readOnly = false,
}) => {
  const { watch } = useFormContext<TFinancialConditionFormValues>();
  const borrowerType = watch('borrowerType')?.value;
  const isLegalEntity = borrowerType === BorrowerType.LegalEntity;

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <FormAutocomplete
        name="borrowerType"
        label="Тип позичальника"
        options={BORROWER_TYPE_OPTIONS}
        disabled={disabled || readOnly}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />

      {borrowerType && (
        <Box sx={documentGenerationFormStyles.fieldsGrid}>
          <FormInput
            name="borrowerName"
            label={isLegalEntity ? 'Повне найменування' : 'ПІБ'}
            disabled={disabled || readOnly}
            fullWidth
            sx={documentGenerationFormStyles.field}
          />
          <FormInput
            name="borrowerCode"
            label={isLegalEntity ? 'ЄДРПОУ' : 'РНОКПП/ІПН'}
            disabled={disabled || readOnly}
            fullWidth
            sx={documentGenerationFormStyles.field}
          />
        </Box>
      )}
      {isLegalEntity && (
        <FormAutocomplete
          name="financialStatementForm"
          label="Тип фінансової звітності"
          options={FINANCIAL_STATEMENT_FORM_OPTIONS}
          disabled={disabled}
          fullWidth
          sx={documentGenerationFormStyles.field}
        />
      )}
    </Box>
  );
};
